import { useConstructInternalLink } from "hooks/useConstructInternalLink";
import ReactMarkdown from "react-markdown";
import { defaultSchema } from "rehype-sanitize";
import rehypeRaw from "rehype-raw";
import rehypeSanitize from "rehype-sanitize";
import remarkGfm from "remark-gfm";

const taskMarkdownSchema = {
  ...defaultSchema,
  attributes: {
    ...defaultSchema.attributes,
    "*": [...(defaultSchema.attributes?.["*"] ?? []), "style"],
    a: [...(defaultSchema.attributes?.a ?? []), "target", "rel"],
  },
};

export const TaskMarkdown = ({
  text,
  className,
  taskContext,
}: {
  text: string;
  className?: string;
  taskContext?: {
    taskId: string;
    groupId?: string;
    entityId?: string;
  };
}) => {
  const { link } = useConstructInternalLink();
  return (
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      rehypePlugins={[rehypeRaw, [rehypeSanitize, taskMarkdownSchema]]}
      className={className}
      components={{
        a({ children, href, ...props }) {
          return (
            <a
              {...props}
              href={link(href, {
                moreQuery: {
                  company: taskContext?.groupId || "",
                  entity: taskContext?.entityId || "",
                },
              })}
            >
              {children}
            </a>
          );
        },
      }}
    >
      {text}
    </ReactMarkdown>
  );
};
